import type { ReactNode } from 'react';

interface PageHeaderProps {
  /** Page title — rendered in Gloock 34/40 (design system v2 `t-h1`). */
  title: ReactNode;
  /** One muted line under the title: what this page is for. */
  description?: ReactNode;
  /** Right-aligned actions. Keep to one primary button per view. */
  actions?: ReactNode;
  /** Small row above the title — a back link, usually. */
  eyebrow?: ReactNode;
  className?: string;
}

/**
 * The page title block every admin page starts with. The display face lives
 * here rather than on a global `h1` rule, so headings inside cards, drawers and
 * tables keep the UI face.
 */
export function PageHeader({ title, description, actions, eyebrow, className = '' }: PageHeaderProps) {
  return (
    <header className={`flex flex-wrap items-end justify-between gap-x-6 gap-y-4 ${className}`}>
      <div className="min-w-0">
        {eyebrow && <div className="mb-2">{eyebrow}</div>}
        <h1 className="page-title">{title}</h1>
        {description && <p className="mt-1 text-[15px] text-ink-500">{description}</p>}
      </div>
      {actions && <div className="flex flex-wrap items-center gap-2.5">{actions}</div>}
    </header>
  );
}
